/** Minimal focus trap for modal dialogs — Tab cycles inside `container`. */
export function createFocusTrap(container: HTMLElement, options?: { restoreFocus?: HTMLElement | null }): () => void {
  const focusableSelector =
    'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  const getFocusable = (): HTMLElement[] =>
    Array.from(container.querySelectorAll<HTMLElement>(focusableSelector)).filter(
      (el) => el.offsetParent !== null || el === document.activeElement,
    );

  const onKeydown = (e: KeyboardEvent): void => {
    if (e.key !== 'Tab') {
      return;
    }
    const items = getFocusable();
    if (items.length === 0) {
      return;
    }
    const first = items[0];
    const last = items[items.length - 1];
    if (!first || !last) {
      return;
    }
    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else if (document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  };

  container.addEventListener('keydown', onKeydown);

  queueMicrotask(() => {
    const items = getFocusable();
    items[0]?.focus();
  });

  return (): void => {
    container.removeEventListener('keydown', onKeydown);
    options?.restoreFocus?.focus();
  };
}
